import i18n from '@/utils/plugins/i18n'

export default {
  /** @param {import('vue').App} app - The Vue instance. */
  install (app) {
    app.mixin({
      methods: {
        /** Super-tiny helper to act as a wrapper for i18n.global.t & this.$t
         *
         * @returns the translated string, if the path exists, or null if it doesn't
         */
        $tFind (initialPath) {
          const pathExists = i18n.global.te(initialPath)
          return pathExists ? i18n.global.t(initialPath) : null
        },
      },
    })
  },
}
